import { ConversationCustomer, WorkItem } from '../models/reports.external';
import { ChannelType, VirtualConversationType } from '../models/reports.internal';

const getCustomerName = (customer: ConversationCustomer | undefined) => customer
  ? [customer.firstName, customer.middleName, customer.lastName].filter(str => str !== '').join(' ')
  : 'unknown';

type ReturnType = {
  conversationId: string | null;
  channelType: ChannelType;
  channelName: string;
  virtualConversationType: VirtualConversationType | null;
  customerName: string;
  customerIdentifier: string;
  isOutbound: boolean | null;
};

function getWorkItemInfoFromMainConversation({ conversations, primaryConversationId, status }: WorkItem): ReturnType {
  if (conversations.length === 0) {
    if (status !== '')
      return { conversationId: null, channelType: status as ChannelType, virtualConversationType: null, customerName: '', customerIdentifier: '', channelName: '', isOutbound: null };

    return { conversationId: null, channelType: 'unknown' as ChannelType, virtualConversationType: null, customerName: '', customerIdentifier: '', channelName: '', isOutbound: null };
  }

  if (conversations.length === 1)
  return {
    conversationId: conversations.first.id,
    channelType: conversations.first.channelType,
    virtualConversationType: conversations.first.virtualConversationType ?? null,
    customerName: getCustomerName(conversations.first.customer),
    customerIdentifier: conversations.first.customer?.customerIdentifier ?? '',
    channelName: conversations.first.channelName,
    isOutbound: conversations.first.channelType === 'virtual' ? true : conversations.first.isOutbound,
  };

const voiceConversations = conversations.filter(c => c.channelType === 'voice');
if (voiceConversations.length > 0)
  return {
    conversationId: voiceConversations.first.id,
    channelType: voiceConversations.first.channelType,
    virtualConversationType: voiceConversations.first.virtualConversationType ?? null,
    customerName: getCustomerName(voiceConversations.first.customer),
    customerIdentifier: voiceConversations.first.customer?.customerIdentifier ?? '',
    channelName: voiceConversations.first.channelName,
    isOutbound: voiceConversations.first.isOutbound,
  };

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const primaryConversation = conversations.find(c => c.id === primaryConversationId!)!;
return {
  conversationId: primaryConversation.id,
  channelType: primaryConversation.channelType,
  virtualConversationType: primaryConversation.virtualConversationType ?? null,
  customerName: getCustomerName(primaryConversation.customer),
  customerIdentifier: primaryConversation.customer?.customerIdentifier ?? '',
  channelName: primaryConversation.channelName,
  isOutbound: primaryConversation.channelType === 'virtual' ? true : conversations.first.isOutbound,
};
}

export default getWorkItemInfoFromMainConversation;